<template>
    <activation-brief-order-provider
        v-slot="{ brief, isLoading, order, products }"
        style="height: 100%"
    >
        <activation-brief-order-view
            v-if="brief && order"
            :brief="brief"
            :order="order"
            :products="products"
        />
    </activation-brief-order-provider>
</template>

<script>
    import ActivationBriefOrderView from '../data-views/activation-briefs/partials/orders/ActivationBriefOrderView';
    import ActivationBriefOrderProvider from '../providers/activation-brief-steps/ActivationBriefOrderProvider';

    export default {
        name: 'ActivationBriefOrderRouterView',
        components: {
            ActivationBriefOrderProvider,
            ActivationBriefOrderView
        }
    };
</script>
